import { api } from '@/core/api';

const baseUrl = 'api/sysparameter';

export const getByParameterName = (parameterName, academicYearId) =>
  api.get(`${baseUrl}/byparametername`, {
    params: { parameterName, academicYearId },
  });
